import React from "react";

import numeral from "numeral";

import { Button } from "aible";

import Select from "react-select";

import { Popover, OverlayTrigger } from "react-bootstrap";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";

import { LineInput } from "components/Inputs/LineInput";

import RawCostsContainer from "containers/CreateWizard/Costs/RawCosts";
import ContinuousImpactContainer from "containers/CreateWizard/Costs/ContinuousImpact";

import { validateCustomFieldName } from "containers/Blueprint/reducer";

import styles from "./style.module.css";

export default class AdvancedCosts extends React.PureComponent {
  constructor(props) {
    super(props);

    const length = props.customFields ? Object.keys(props.customFields).length : 0;

    this.state = {
      customFieldName: "CustomField" + (length + 1),
      customFieldDesc: "",
      showFormula: false,
      isSetup: true
    };
  }

  renderCostsCheck() {
    const { hideCosts, updateHideCosts } = this.props;

    return (
      <div className={styles.costsCheck} onClick={() => updateHideCosts(!hideCosts)}>
        <input type="checkbox" checked={!hideCosts} onChange={() => {}} />
        {"Include soft benefits and costs"}
      </div>
    );
  }

  renderCustomField(customField) {
    return (
      <div className={styles.customField} key={customField.id}>
        <div className={styles.customFieldLabel}>{customField.id}</div>
        <div className={styles.customFieldDesc}>{customField.desc}</div>
      </div>
    );
  }

  renderAdvancedInputs() {
    const {
      isNext,
      nextId,
      advancedInputs,
      customFields,
      setup,
      conversionGain,
      conversionCost,
      conversionSaved,
      conversionMissed,
      advancedRevenue,
      advancedCost,
      netImpactLabel,
      updateCustomValue,
      updateCustomField,
      updateCustomFieldById,
      isContinuous,
      overestimateLabel,
      underestimateLabel,
      truePositiveLabel,
      falsePositiveLabel,
      trueNegativeLabel,
      falseNegativeLabel,
      advancedRevenueLabel,
      advancedCostLabel,
      updateOverestimateLabel,
      updateUnderestimateLabel,
      updateFalsePositiveLabel,
      updateTruePositiveLabel,
      updateTrueNegativeLabel,
      updateFalseNegativeLabel,
      updateAdvancedRevenueLabel,
      updateAdvancedCostLabel,
      updateNetImpactLabel,
      customValues,
      projectId,
      updateAdvancedInput
    } = this.props;

    const { customFieldName, customFieldDesc, isSetup } = this.state;

    const inputs = isContinuous
      ? [
          {
            label: (
              <div className={styles.aLabs}>
                <LineInput
                  topLabel={"Cost of Overestimate"}
                  value={overestimateLabel}
                  onChange={(val) => updateOverestimateLabel(val)}
                  isMediumBox
                />
                {" = "}
              </div>
            ),
            val: "truePositive",
            dImpact: isNaN(conversionGain) ? conversionGain : Math.abs(conversionGain),
            key: "conversionGain"
          },
          {
            label: (
              <div className={styles.aLabs}>
                <LineInput
                  topLabel={"Cost of Underestimate"}
                  value={underestimateLabel}
                  onChange={(val) => updateUnderestimateLabel(val)}
                  isMediumBox
                />
                {" = "}
              </div>
            ),
            val: "falsePositive",
            dImpact: isNaN(conversionCost) ? conversionCost : Math.abs(conversionCost),
            key: "conversionCost"
          }
        ]
      : [
          {
            label: (
              <div className={styles.aLabs}>
                <LineInput
                  topLabel={"Impact"}
                  value={netImpactLabel}
                  onChange={(val) => updateNetImpactLabel(val)}
                  isMediumBox
                />{" "}
                &nbsp; &nbsp;
              </div>
            )
          },
          {
            label: (
              <div className={styles.aLabs}>
                <LineInput
                  topLabel={"Per Unit Revenue"}
                  value={advancedRevenueLabel}
                  onChange={(val) => updateAdvancedRevenueLabel(val)}
                  isMediumBox
                />
                {" = "}
              </div>
            ),
            val: "advancedRevenue",
            dImpact: advancedRevenue,
            key: "advancedRevenue"
          },
          {
            label: (
              <div className={styles.aLabs}>
                <LineInput
                  topLabel={"Per Unit Cost"}
                  value={advancedCostLabel}
                  onChange={(val) => updateAdvancedCostLabel(val)}
                  isMediumBox
                />
                {" = "}
              </div>
            ),
            val: "advancedCost",
            dImpact: advancedCost
          },
          {
            label: (
              <div className={styles.aLabs}>
                <LineInput value={truePositiveLabel} onChange={(val) => updateTruePositiveLabel(val)} isMediumBox />
                {" = "}
              </div>
            ),
            val: "truePositive",
            dImpact: conversionGain,
            key: "conversionGain"
          },
          {
            label: (
              <div className={styles.aLabs}>
                <LineInput value={falsePositiveLabel} onChange={(val) => updateFalsePositiveLabel(val)} isMediumBox />
                {" = "}
              </div>
            ),
            val: "falsePositive",
            dImpact: conversionCost,
            key: "conversionCost"
          },
          {
            label: (
              <div className={styles.aLabs}>
                <LineInput value={trueNegativeLabel} onChange={(val) => updateTrueNegativeLabel(val)} isMediumBox />
                {" = "}
              </div>
            ),
            val: "trueNegative",
            dImpact: conversionSaved,
            key: "conversionSaved"
          },
          {
            label: (
              <div className={styles.aLabs}>
                <LineInput value={falseNegativeLabel} onChange={(val) => updateFalseNegativeLabel(val)} isMediumBox />
                {" = "}
              </div>
            ),
            val: "falseNegative",
            dImpact: conversionMissed,
            key: "conversionMissed"
          }
        ];

    const cfList =
      customFields &&
      Object.keys(customFields)
        .map((c) => c)
        .join(", ");

    const length = customFields ? Object.keys(customFields).length : 0;

    const validName = validateCustomFieldName(customFieldName);

    return (
      <div className={styles.advancedInputs} style={isNext ? { display: "block" } : {}}>
        <div className={styles.leftCosts} style={isNext ? { width: "100%", height: "auto" } : {}}>
          <div className={styles.newCustomField}>
            <div className={styles.cfInput}>
              <LineInput
                isMediumBox
                value={customFieldName}
                onChange={(val) => this.setState({ customFieldName: val })}
              />
              <div className={styles.cfError}>
                {validName
                  ? ""
                  : "Alphanumeric characters, underscores, and currency symbols only as one word or string"}
                &nbsp;
              </div>
            </div>
            <div className={styles.cfInput}>
              <LineInput
                isMediumBox
                value={customFieldDesc}
                placeholder={"Enter Description for " + customFieldName}
                onChange={(val) => this.setState({ customFieldDesc: val })}
              />
              <div className={styles.cfError}>&nbsp;</div>
            </div>
            <Button
              type="secondary"
              onClick={() => {
                updateCustomField(
                  {
                    id: customFieldName,
                    desc: customFieldDesc
                  },
                  nextId
                );
                this.setState({
                  customFieldName: "CustomField" + (length + 2),
                  customFieldDesc: ""
                });
              }}
              defaultValue={customFieldName}
              disabled={!validName}
              style={{ marginTop: "3px" }}
            >
              {isNext ? "Add" : "Add Custom Field"}
            </Button>
          </div>
          <div className={styles.aHolds} style={isNext ? { marginBottom: "0px" } : {}}>
            {this.renderBasic(true)}
          </div>
        </div>
        <div className={styles.rightCosts} style={isNext ? { width: "100%", marginLeft: "0px" } : {}}>
          <div className={styles.aiHeader}>
            {"Enter the function you want to evaluate in the input boxes below. " +
              "You may include the variables (custom fields) that were added above in your calculations"}
          </div>
          {inputs.map((i, index) => {
            const isError = setup && setup.errorCosts && setup.errorCosts[i.key] && setup.errorCosts[i.key] === "Error";

            let impactDisplay = i.dImpact;
            if (isError) {
              impactDisplay = "Error";
            } else if (!isNaN(i.dImpact)) {
              if (Math.abs(Number(i.dImpact)) < 1) {
                impactDisplay = Number(i.dImpact).toPrecision(3);
              } else {
                impactDisplay = numeral(i.dImpact).format("0.[00]");
              }
            }

            return (
              <div className={styles.aInput} key={i.val ? i.val : "input" + index}>
                <div className={styles.aInputLabel}>
                  <div className={styles.aInputLabelFixed}>
                    {i.label}
                    {i.inputLabel}
                  </div>
                  {i.val !== undefined ? (
                    <React.Fragment>
                      <div style={{ flexGrow: 1, maxWidth: "50%" }}>
                        <LineInput
                          isMediumBox
                          placeholder="Enter function to evaluate"
                          onChange={(val) => updateAdvancedInput(i.val, val, projectId)}
                          value={
                            advancedInputs && advancedInputs[i.val] !== undefined
                              ? advancedInputs[i.val]
                              : isContinuous
                                ? Math.abs(i.dImpact)
                                : i.dImpact
                          }
                        />
                      </div>
                      <div
                        style={{
                          minWidth: isNext ? "0px" : "200px",
                          color: isError ? "#C03E5A" : undefined
                        }}
                      >
                        <div>{impactDisplay}</div>
                      </div>
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <div style={{ width: "100%" }} />
                      <div style={{ minWidth: isNext ? "0px" : "200px" }} />
                    </React.Fragment>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }

  renderAdvancedRun() {
    const {
      customFields,
      conversionGain,
      conversionCost,
      conversionSaved,
      conversionMissed,
      customValues,
      advancedInputs,
      truePositiveLabel,
      falsePositiveLabel,
      trueNegativeLabel,
      falseNegativeLabel,
      renderNormal,
      updateFalsePositiveLabel,
      updateTruePositiveLabel,
      updateTrueNegativeLabel,
      updateFalseNegativeLabel,
      updateCustomValue,
      updateCustomFieldById,
      deleteCustomFieldById
    } = this.props;
    const { showFormula, isSetup } = this.state;

    return (
      <div className={styles.advancedRun}>
        {customFields &&
          Object.keys(customFields)
            .filter((c) => customFields[c] !== undefined)
            .map((c, i) => {
              const customField = customFields[c];
              return (
                <div className={styles.customFieldInput} key={i}>
                  <Button
                    type="secondary"
                    onClick={() => deleteCustomFieldById(customField.id)}
                    style={{ marginRight: "5px" }}
                  >
                    <FontAwesomeIcon icon={faTrash} />
                  </Button>
                  <div className={styles.aInputRun} key={customField.id}>
                    <div className={styles.aLabels}>
                      <div className={styles.aLab}>{customField.id}</div>
                      <div className={styles.aDesc} style={{ marginLeft: "10px" }}>
                        {customField.desc}
                      </div>
                    </div>
                    <div>
                      <div className={styles.cfInput}>
                        <LineInput
                          isMediumBox
                          onChange={(val) => updateCustomValue(customField.id, val)}
                          defaultValue={customValues && customValues[customField.id]}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
      </div>
    );
  }

  renderAdvanced() {
    const {
      id,
      blueprintId,
      isAdvanced,
      customFields,
      updateIsAdvanced,
      truePositiveLabel,
      falsePositiveLabel,
      trueNegativeLabel,
      falseNegativeLabel,
      updateFalsePositiveLabel,
      updateTruePositiveLabel,
      updateTrueNegativeLabel,
      updateFalseNegativeLabel,
      updateCustomField
    } = this.props;
    const { customFieldName, customFieldDesc, isSetup } = this.state;

    const length = customFields ? Object.keys(customFields).length : 0;

    const validName = validateCustomFieldName(customFieldName);

    return <div className={styles.setupAdvanced}>{this.renderAdvancedInputs()}</div>;
  }

  renderField(customField, index) {
    const {
      isEditing,
      customValues,
      isContinuous,
      updateCustomValue,
      updateCustomFieldById,
      deleteCustomFieldById,
      toggleCustomMapping,
      customMappings,
      customMappingOptions,
      setCustomMapping
    } = this.props;

    const currMapping = customMappings && customMappings[customField.id];

    const currValue = customValues && customValues[customField.id];

    return (
      <div className={styles.fieldInput} key={index}>
        {isEditing && (
          <Button type="secondary" onClick={() => deleteCustomFieldById(customField.id)} style={{ marginRight: "5px" }}>
            <FontAwesomeIcon icon={faTrash} />
          </Button>
        )}
        <div className={styles.aInputRun} key={customField.id}>
          <div className={styles.cfLabel}>
            <div className={styles.aLab}>{customField.id}</div>
            <div className={styles.aDesc}>{customField.desc}</div>
          </div>
          <div>
            <div className={styles.cFieldInput}>
              <LineInput
                isMediumBox
                onChange={(val) => updateCustomValue(customField.id, val)}
                value={
                  currMapping && currMapping === true
                    ? "Define field mapping to calculate value"
                    : currValue && currMapping
                      ? numeral(currValue).format(currValue > 100 ? "0" : "0.[00]")
                      : currValue
                }
                isDisabled={currMapping && currMapping === true}
              />
              <div
                className={styles.aDesc + " " + styles.cFieldOption}
                onClick={() => {
                  toggleCustomMapping(customField.id);
                }}
              >
                <input
                  type="checkbox"
                  style={{ margin: "0px 8px 2px 0px" }}
                  checked={currMapping}
                  onChange={() => {}}
                />
                <OverlayTrigger
                  placement="top"
                  trigger={["hover"]}
                  rootClose
                  overlay={
                    <Popover id="popover-positioned-top">
                      <div className={styles.tooltip}>
                        {"Aible will base its prediction on the value found in the selected field. " +
                          "If this checked, users will always be required to select a reference field to find the value."}
                      </div>
                    </Popover>
                  }
                >
                  <span>{"USE A FIELD IN THE DATASET FOR THIS VALUE"}</span>
                </OverlayTrigger>
              </div>
              {currMapping && (
                <Select
                  options={customMappingOptions}
                  onChange={(val) => setCustomMapping(customField.id, val ? val.value : val)}
                  value={(customMappingOptions || []).find((e) => e.value === currMapping)}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderBasic(disallowInputs) {
    const { isContinuous, isNext, customFields, advancedInputs, priceColumn, isAcademicResultsCard, blueprintId } =
      this.props;
    const { showImpacts } = this.state;

    const hasCustomFields = blueprintId !== undefined && customFields && Object.keys(customFields).length > 0;

    const benefits = Object.keys(customFields)
      .filter((c) => !customFields[c].isCost && customFields[c].isBenefit)
      .map((c) => customFields[c]);

    const costs = Object.keys(customFields)
      .filter((c) => customFields[c].isCost && !customFields[c].isBenefit)
      .map((c) => customFields[c]);

    const both = Object.keys(customFields)
      .filter((c) => customFields[c].isCost && customFields[c].isBenefit)
      .map((c) => customFields[c]);

    const other = Object.keys(customFields)
      .filter((c) => !customFields[c].isCost && !customFields[c].isBenefit)
      .map((c) => customFields[c]);

    return (
      <div className={styles.basic}>
        {!hasCustomFields || showImpacts ? (
          isContinuous ? (
            <ContinuousImpactContainer {...this.props} noEdit={disallowInputs ? true : undefined} hideExtra />
          ) : (
            <RawCostsContainer {...this.props} noEdit={disallowInputs ? true : undefined} hideExtra />
          )
        ) : isContinuous ? (
          <div
            className={styles.outerCosts}
            style={
              isNext
                ? {
                    alignItems: "flex-start",
                    justifyContent: "center",
                    padding: "0px",
                    marginTop: "0px"
                  }
                : { alignItems: "flex-start", justifyContent: "center" }
            }
          >
            {Object.keys(customFields).length > 0 && (
              <div className={styles.aImpacts}>
                <div className={styles.impactHeader}>{"Custom Fields:"}</div>
                <div className={styles.fieldsList}>
                  {Object.keys(customFields).map((c, i) => this.renderField(customFields[c], i))}
                </div>
              </div>
            )}
          </div>
        ) : (
          <div className={styles.outerCosts} style={{ alignItems: "flex-start", justifyContent: "center" }}>
            {customFields && customFields.length > 0 && (
              <div className={styles.aImpacts}>
                <div className={styles.fieldsList}>
                  {Object.keys(customFields).map((c, i) => this.renderField(customFields[c], i))}
                </div>
              </div>
            )}
          </div>
        )}
        {priceColumn && (
          <div className={styles.botLabel}>
            {"The impacts are being scaled by " +
              priceColumn +
              ". You will be able to change this in your dataset settings"}
          </div>
        )}
        {!isAcademicResultsCard && hasCustomFields ? (
          <div className={styles.impactsBtn}>
            <Button type="secondary" onClick={() => this.setState({ showImpacts: !showImpacts })}>
              {showImpacts ? "Hide Impacts" : "Show Impacts"}
            </Button>
          </div>
        ) : (
          ""
        )}
      </div>
    );
  }

  render() {
    const {
      id,
      conversionGain,
      conversionCost,
      conversionSaved,
      conversionMissed,
      blueprintId,
      customValues,
      currentROI,
      convergeError,
      customFields,
      truePositive,
      falsePositive,
      trueNegative,
      falseNegative,
      truePositiveLabel,
      falsePositiveLabel,
      trueNegativeLabel,
      falseNegativeLabel,
      netImpactLabel,
      isShow,
      isAdvanced,
      isEditing,
      isNext,
      hideCosts,
      outcome,
      success,
      successOptions,
      updateFalsePositive,
      updateTruePositive,
      updateTrueNegative,
      updateFalseNegative,
      updateFalsePositiveLabel,
      updateTruePositiveLabel,
      updateTrueNegativeLabel,
      updateFalseNegativeLabel,
      updateConversionGain,
      updateConversionCost,
      updateConversionSaved,
      updateConversionMissed,
      updateIsAdvanced,
      updateNetImpactLabel,
      isAcademicResultsCard
    } = this.props;

    const { isSetup } = this.state;

    const hasCustomFields = blueprintId !== undefined && customFields && Object.keys(customFields).length > 0;

    return (
      <div className={styles.body} style={isNext ? { paddingBottom: "0px" } : {}}>
        {isAcademicResultsCard || !isEditing ? this.renderBasic() : this.renderAdvanced()}
      </div>
    );
  }
}
